function checkDataType (obj, type) {
  return Object.prototype.toString.call(obj).toLowerCase() === `[object ${type}]`
}

export default {
  // 判断数据类型
  checkDataType,
  // 生成dom ID
  createDomID (len) {
    return Number(Math.random().toString().substr(3, len)).toString(36)
  },
  // 简单拷贝对象
  copyObj (obj) {
    return JSON.parse(JSON.stringify(obj))
  },
  // 时间格式化
  parseTime (time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
        time = parseInt(time)
      }
      if ((typeof time === 'number') && (time.toString().length === 10)) {
        time = time * 1000
      }
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return time_str
  },
  // 是否是空对象
  isEmptyObject (object) {
    if (Object.keys(object).length > 0) {
      return false
    }
    return true
  },
  // 是否是字符串
  isString (obj) {
    return checkDataType(obj, 'string')
  },
  // 给url添加协议头
  fixUrl (url) {
    if (url.indexOf('http') > -1) return url
    return 'http://' + url
  },
  // 是不是url
  isUrl (str) {
    !str && (str = '')
    return /^(?=^.{3,255}$)((http(s)?:\/\/)|(\/\/))?(www\.)?[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+(:\d+)*(\/\w+)*(\.\w+)?([?&]\w+=\w*)*$/.test(str)
  },
  // 是否是已发布链接
  isPublishUrl () {
    let path = window.location.pathname
    return path.indexOf('topic.html') > -1
  },
  // 获取主域
  getDomain () {
    return document.domain
      .split('.')
      .slice(-2)
      .join('.')
  },
  // 获取Cookie
  getCookie (name) {
    let strcookie = document.cookie
    let arrcookie = strcookie.split('; ')
    for (let i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split('=')
      if (arr[0] === name) {
        return arr[1]
      }
    }
    return ''
  },
  // 样式表转换成样式字符串
  styleArrayToStyle (styleArray = []) {
    const ret = []
    styleArray.forEach((item) => {
      const unit = item.unit || ''
      if (item.val) {
        if (Array.isArray(item.attr)) {
          item.attr.forEach((atr, i) => {
            ret.push(atr + ': ' + item.val[i])
          })
        } else if (item.attr === 'background-image' || item.attr === 'src') {
          ret.push('background-image: url(' + item.val + ')')
        } else {
          ret.push(item.attr + ': ' + item.val + unit)
        }
      }
    })
    return ret.join(';')
  }
}
